import { TESTIMONIALS } from "@/data/content";
import { Quotes } from "@phosphor-icons/react";

export default function Testimonials() {
  return (
    <section
      className="bg-[#0A0A0B] text-[#F7F5F0] py-10 md:py-16 px-5 md:px-12 lg:px-24"
      data-testid="testimonials-section"
    >
      <div className="max-w-3xl mb-5 md:mb-8">
        <p className="tcp-overline text-[#C29B62] mb-2 md:mb-3">Travelers' Words</p>
        <h2 className="font-serif text-3xl sm:text-5xl lg:text-6xl tracking-tighter leading-tight md:leading-none">
          They flew with us. <br />
          <em className="italic" style={{ color: "#C29B62" }}>Then they sent friends.</em>
        </h2>
      </div>

      {/* Horizontal swipe carousel on mobile · 3-col grid on desktop.
          Mobile cards are ~85% viewport-width so a sliver of the next card
          peeks in — a classic CheapOair / iOS pattern that hints "swipe me". */}
      <div
        className="
          flex md:grid md:grid-cols-3 gap-4 md:gap-8
          overflow-x-auto md:overflow-visible no-scrollbar
          snap-x snap-mandatory md:snap-none
          -mx-5 md:mx-0 px-5 md:px-0 pb-3 md:pb-0
        "
        data-testid="testimonials-track"
      >
        {TESTIMONIALS.map((t, i) => (
          <figure
            key={i}
            className="
              w-[85%] md:w-auto shrink-0 md:shrink
              snap-start
              border border-white/10 p-6 md:p-7 lift bg-[#141415]/40
              flex flex-col
            "
            data-testid={`testimonial-${i}`}
          >
            <Quotes size={28} weight="fill" className="text-[#C29B62] mb-3 md:mb-4 md:w-9 md:h-9" />
            <blockquote className="font-serif text-base md:text-lg leading-snug tracking-tight text-[#F7F5F0] mb-4 md:mb-5 flex-1">
              "{t.quote}"
            </blockquote>
            <figcaption>
              <p className="text-sm font-semibold">{t.name}</p>
              <p className="text-xs text-[#A09E9A] mt-1">{t.title}</p>
            </figcaption>
          </figure>
        ))}
      </div>

      {/* Mobile-only swipe hint */}
      <p className="md:hidden mt-3 text-[10px] tracking-[0.22em] uppercase text-[#A09E9A] text-center">
        Swipe →
      </p>
    </section>
  );
}
